import { render, staticRenderFns } from "./SustainabilityImpact2409.vue?vue&type=template&id=c2e9b45a&scoped=true&"
import script from "./SustainabilityImpact2409.vue?vue&type=script&lang=ts&"
export * from "./SustainabilityImpact2409.vue?vue&type=script&lang=ts&"
import style0 from "./SustainabilityImpact2409.vue?vue&type=style&index=0&id=c2e9b45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e9b45a",
  null
  
)

export default component.exports